import { Typography, tk } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';

const SheetContentTitle = styled(Typography)`
  margin-bottom: ${tk('spacing_md')};
`;

const FieldSection = styled.div`
  background-color: ${tk('color_semantic_bg_subdued')};
  padding: ${tk('spacing_sm')};
  margin-bottom: ${tk('spacing_xs')};
  border-radius: ${tk('radius_medium')};
`;

const FieldSectionTitle = styled(Typography)`
  color: ${tk('color_semantic_text_subdued')};
`;

export { SheetContentTitle, FieldSection, FieldSectionTitle };
